//WE.Flow.Html.Models.WorkspaceModel
import { MenuManifest } from "./MenuManifest";
import { ComponentManifest } from "./ComponentManifest";
import { DialogManifest } from "./DialogManifest";
import { LicenseBundle } from "./LicenseBundle";
import { SelectedProduct } from "./SelectedProduct";
import { Theme } from "./Theme";
import { UserContextTabManifest } from "./UserContextTabManifest";

export class WorkspaceModel {
    clientLogLevel: number = 0;
    configMenuManifest: MenuManifest = null;
    configMenuManifest2: MenuManifest = null;
    creditComponentManifest: ComponentManifest = null;
    customGroupMenuManifest: MenuManifest = null;
    environmentDescription: string = "";
    inactivityDialogTimeout: number = 0;
    inactivityDialogTimeoutUnsaved: number = 0;
    inactivityTimeout: number = 0;
    inspectorDialogManifest: DialogManifest = null;
    licenseBundles: LicenseBundle[] = null;
    logoutUrl: string = "";
    metaConfigs: any[] = null;
    moduleDescription: string = "";
    productionMode: boolean = false;
    roleBlacklist: string[] = null;
    runtimeContext: string = "";
    searchMenuManifest: MenuManifest = null;
    selectedProduct: SelectedProduct = null;
    selectedTheme: string = "";
    singleModule: string = "";
    statisticsMenuManifest: MenuManifest = null;
    compilationsMenuManifest: MenuManifest = null;
    supportDocumentMenuManifest: MenuManifest = null;
    backgroundJobsMenuManifest: MenuManifest = null;
    systemInformation: boolean = false;
    systemVersion: string = "";
    themes: Theme[] = null;
    themeSelectorManifest: UserContextTabManifest = null;
    useProductSelector: boolean = false;
    userId: string = "";
    userName: string = "";
    userContextTabManifests: UserContextTabManifest[] = null;
}
